import { render, staticRenderFns } from "./ChoosePopularButtons.vue?vue&type=template&id=4dcfb42b&scoped=true"
import script from "./ChoosePopularButtons.vue?vue&type=script&lang=js"
export * from "./ChoosePopularButtons.vue?vue&type=script&lang=js"
import style0 from "./ChoosePopularButtons.vue?vue&type=style&index=0&id=4dcfb42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfb42b",
  null
  
)

export default component.exports